import { observable, action, computed, makeObservable } from "mobx";
import { isValidEmail } from "../../logic/ValidationChecks/Validation";
import { Fields } from "./Fields";
import { validateCredentials } from "../../logic/ValidationChecks";

interface ICredentialsFields {
    email: string;
    password: string;
    confirmedPassword: string;
}

export class Credentials extends Fields<ICredentialsFields, Credentials> implements ICredentialsFields {
    @observable email = "";
    @observable password = "";
    @observable confirmedPassword = "";

    constructor() {
        // TODO: [mobx-undecorate] verify the constructor arguments and the arguments of this automatically generated super call
        super();

        makeObservable(this);
    }

    @action setEmail(newEmail: string) {
        this.email = newEmail;
    }

    @action setPassword(newPassword: string) {
        this.password = newPassword;
    }

    @action setConfirmedPassword(newConfirmedPassword: string) {
        this.confirmedPassword = newConfirmedPassword;
    }

    @computed get emailIsValid() {
        return isValidEmail(this.email);
    }

    @computed get passwordsMatch() {
        return this.password === this.confirmedPassword;
    }

    @computed get validationErrors() {
        return validateCredentials(this);
    }

    serialize() {
        return {
            username: this.email.trim(),
            password: this.password
        }
    }
}